export function ErrorFallback() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-stone-50 font-sans px-4">
      <div className="text-center max-w-md">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-stone-900 text-white text-2xl font-bold">
          →
        </div>
        <h1 className="font-serif text-3xl text-stone-900 mb-3">
          Something went wrong
        </h1>
        <p className="text-stone-500 leading-relaxed mb-8">
          An unexpected error occurred. We've been notified and are looking into
          it. Reload the page to keep exploring quotes.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="rounded-2xl bg-stone-900 px-7 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-stone-800 active:scale-[0.98]"
        >
          Reload
        </button>
      </div>
    </div>
  );
}
